export const bAndOConfig = {
  //VHW_SBX
  ['6b557caf-1766-4271-9489-d71873eac482']: {
    web: 'https://vhw.kleinreparatur.schulung.enapt.de',
    mobile: 'https:vhw.kleinreparatur.schulung.enapt.de',
  }, //VHW_PROD
  ['c05d8e95-6891-401a-93da-bfd8d7cf28c4']: {
    web: 'https://vhw.kleinreparatur.de',
    mobile: 'https:vhw.kleinreparatur.de',
  },
  //SaaS_test_itg
  ['fd3f402c-70a7-4523-878c-b070c50dd059']: {
    web: 'https://vhw.kleinreparatur.schulung.enapt.de',
    mobile: 'https:vhw.kleinreparatur.schulung.enapt.de',
  },
};
